import React from 'react';
import { useWindowContext } from '../Context/WindowContext';
import { useAuth } from '../Components/StoredDetails';
import PageWindow from './PageWindow';
import AdminDashboard from '../Forms/Dashboard';


const ContentArea = ({ dashboardResetKey = 0 }) => {
  const { windows, activeWindowId, setActiveWindow } = useWindowContext();
  const { authData } = useAuth();

  const visibleWindows = windows.filter((window) => !window.minimized);
  const userType = (authData?.user?.UserType || '').toString().trim().toLowerCase();

  const dashboardByRole = {
    admin: AdminDashboard
  };

  const DashboardComponent = dashboardByRole[userType] || AdminDashboard;

  return (
    <section className="Content-Area">
      {visibleWindows.length === 0 ? (
        <div className="Empty-State" key={dashboardResetKey}>
          <DashboardComponent key={dashboardResetKey} />
        </div>
      ) : (
        visibleWindows.map((window, index) => {
          const isActive = activeWindowId === window.id;
          return (
            <div
              key={window.id}
              className={`window-layer ${isActive ? 'active' : ''}`}
              style={{ zIndex: isActive ? 1000 : 20 + index }}
              onClick={() => setActiveWindow(window.id)}
            >
              <PageWindow window={window} index={index} />
            </div>
          );
        })
      )}
    </section>
  );
};

export default ContentArea;
